import { RuleListType } from "./enums";
import { RuleId } from "./rule-id";

export enum ConditionOperator {
  Equals = 'equals',
  Like = 'like',
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  Between = 'between'
}

export interface Condition {
  operator: ConditionOperator;
  value: string;
}

export interface Conditions {
  alternateQuality?: Condition;
  alwaysShow?: Condition;
  anyEnchantment?: Condition;
  archnemesisMod?: Condition;
  areaLevel?: Condition;
  baseArmour?: Condition;
  baseDefencePercentile?: Condition;
  baseEnergyShield?: Condition;
  baseEvasion?: Condition;
  baseType?: Condition;
  baseWard?: Condition;
  blightedMap?: Condition;
  class?: Condition;
  corrupted?: Condition;
  corruptedMods?: Condition;
  dropLevel?: Condition;
  elderItem?: Condition;
  elderMap?: Condition;
  enchantmentPassiveNode?: Condition;
  enchantmentPassiveNum?: Condition;
  foulborn?: Condition;
  fracturedItem?: Condition;
  gemLevel?: Condition;
  gemQualityType?: Condition;
  hasCruciblePassiveTree?: Condition;
  hasEaterOfWorldsImplicit?: Condition;
  hasEnchantment?: Condition;
  hasExplicitMod?: Condition | Condition[];
  hasImplicitMod?: Condition;
  hasInfluence?: Condition;
  hasSearingExarchImplicit?: Condition;
  hasVaalUniqueMod?: Condition;
  height?: Condition;
  identified?: Condition;
  isVaalUnique?: Condition;
  itemLevel?: Condition;
  linkedSockets?: Condition;
  mapTier?: Condition;
  memoryStrands?: Condition;
  mirrored?: Condition;
  quality?: Condition;
  rarity?: Condition;
  replica?: Condition;
  scourged?: Condition;
  shapedMap?: Condition;
  shaperItem?: Condition;
  socketGroup?: Condition;
  sockets?: Condition;
  stackSize?: Condition;
  synthesisedItem?: Condition;
  transfiguredGem?: Condition;
  twiceCorrupted?: Condition;
  uberBlightedMap?: Condition;
  unidentifiedItemTier?: Condition;
  waystoneTier?: Condition;
  width?: Condition;
  zanaMemory?: Condition;
  // Additional, unrecognised condition names map to an array or single condition.
  [key: string]: Condition | Condition[] | undefined;
}

export interface Actions {
  playAlertSound?: string;
  playAlertSoundPositional?: string;
  customAlertSound?: string;
  customAlertSoundOptional?: string;
  disableDropSound?: string;
  enableDropSound?: string;
  disableDropSoundIfAlertSound?: string;
  enableDropSoundIfAlertSound?: string;
  minimapIcon?: string;
  playEffect?: string;
  setBackgroundColor?: string;
  setBorderColor?: string;
  setFontSize?: string;
  setTextColor?: string;
  // Unrecognised actions fall back here.
  [key: string]: string | undefined;
}

export interface RuleDescription {
  name?: string;
  id?: RuleId;
  completeId?: string;
  ruleListType?: RuleListType;
  ruleListIndex?: number;
}

export class FilterBlock {
  show: boolean = false;
  hide: boolean = false;
  partial: boolean = false;

  conditions: Conditions = {};
  actions: Actions = {};

  ruleDescription: RuleDescription = {};

  fullText?: string;
}
